window.nullsCartUpdate = function (count) {
if (count > 0) {

$(".site-header__cart-indicator").removeClass("hide");
$(".site-header__cart-indicator").addClass("nullsShowCount");
$(".site-header__cart-indicator").html(count);
$(".icon-cart").addClass("nullsIcon-cart");
}
else {
$(".site-header__cart-indicator").addClass("hide");
$(".site-header__cart-indicator").removeClass("nullsShowCount");
$(".icon-cart").removeClass("nullsIcon-cart");
}
/*
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function (cart) {
            if (cart.item_count > 0) {
                $(".site-header__cart-indicator").removeClass("hide");
                $(".site-header__cart-indicator").addClass("nullsShowCount");
                $(".site-header__cart-indicator").html(cart.item_count);
                $(".icon-cart").addClass("nullsIcon-cart");
            }
            else {
                $(".site-header__cart-indicator").addClass("hide");
                $(".site-header__cart-indicator").removeClass("nullsShowCount");
                $(".icon-cart").removeClass("nullsIcon-cart");
            }

        }
    });
*/
}
function nullsGetDay(){
var now =new Date();
var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
days = ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'];
var months = [ 'januar', 'februar', 'marts', "april", 'maj', 'juni','juli', "august", "september", 'oktober', "november", "december" ];
var now_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
var kacGun=0;
//saat utcye gore unutma!!!!onemli denmark +2
if(now.getUTCHours()<12)
{
kacGun=1;
}
else
{
kacGun=2;
}
var ilkGun=add_business_days(kacGun);
var ikinciGun=add_business_days((kacGun+1));

$('.nullsDeliveryNote').html(" Forventet leveringsdato: "+ days[ilkGun.getDay()] +" d. "+ ilkGun.getDate() +"  eller "+ days[ikinciGun.getDay()] +" d. "+ ikinciGun.getDate() +" "+ months[ikinciGun.getMonth()]);
}
function add_business_days(days) {
var now1=new Date();
var now =new Date(now1.getUTCFullYear(), now1.getUTCMonth(), now1.getUTCDate(),  now1.getUTCHours(), now1.getUTCMinutes(), now1.getUTCSeconds());
var dayOfTheWeek = now.getDay();
var calendarDays = days;
var deliveryDay = dayOfTheWeek + days;
if (deliveryDay >= 6) {
//deduct this-week days
days -= 6 - dayOfTheWeek;
//count this coming weekend
calendarDays += 2;
//how many whole weeks?
deliveryWeeks = Math.floor(days / 5);
//two days per weekend per week
calendarDays += deliveryWeeks * 2;
}
now.setTime(now.getTime() + calendarDays * 24 * 60 * 60 * 1000);
return now;
}
function nullsFixCart(){
//cart header 48 ve footer 170 20 kafadan yok
//inner maxheigt height - 235
var nullsHeight=$(window).height()-194;
  //share soft disable
//$('.ajaxcart__inner').css('max-height',nullsHeight+'px');
}
//nullsCartUpdate();
jQuery(document).ready(function ($) {

//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
    var $L = 1200,
        $menu_navigation = $('#main-nav'),
        $cart_trigger = $('.cd-cart-trigger'),
        $lateral_cart = $('#cd-cart'),
        $shadow_layer = $('#cd-shadow-layer');

$('.drawer__close').on('click',function (event) {
$shadow_layer.trigger('click');
});
//open cart
    $cart_trigger.on('click', function (event) {
        event.preventDefault();
//close lateral menu (if it's open)
        $menu_navigation.removeClass('speed-in');
        toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
    });

//close lateral cart or lateral menu
    $shadow_layer.on('click', function () {
        $shadow_layer.removeClass('is-visible');
// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
        if ($lateral_cart.hasClass('speed-in')) {
            $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
              //  $('body').removeClass('nulls-overflow-hidden');
            });
$('body').removeClass('nulls-overflow-hidden');
//$('.ajaxcart__footer').fadeOut('fast');
            $menu_navigation.removeClass('speed-in');
        } else {
            $menu_navigation.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('body').removeClass('nulls-overflow-hidden');
            });
            $lateral_cart.removeClass('speed-in');
        }
    });

//move #main-navigation inside header on laptop
//insert #main-navigation after header on mobile
    move_navigation($menu_navigation, $L);
    $(window).on('resize', function () {
        move_navigation($menu_navigation, $L);

        if ($(window).width() >= $L && $menu_navigation.hasClass('speed-in')) {
            $menu_navigation.removeClass('speed-in');
            $shadow_layer.removeClass('is-visible');
            $('body').removeClass('nulls-overflow-hidden');
        }

    });
});

function toggle_panel_visibility($lateral_panel, $background_layer, $body) {
    if ($lateral_panel.hasClass('speed-in')) {
// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
        $lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
            $body.removeClass('nulls-overflow-hidden');
        });
        $background_layer.removeClass('is-visible');

    } else {
        $lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
           // $body.addClass('nulls-overflow-hidden'); burasi alt satira aldim
        });
$body.addClass('nulls-overflow-hidden');
        $background_layer.addClass('is-visible');
    }
}

function move_navigation($navigation, $MQ) {
    if ($(window).width() >= $MQ) {
        $navigation.detach();
        $navigation.appendTo('header');
    } else {
        $navigation.detach();
        $navigation.insertAfter('header');
    }
}

/////////////////////////
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
Shopify.formatMoney = function(cents, format) {
var value = '',
placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
formatString = (format || this.money_format);

if (typeof cents == 'string') {
cents = cents.replace('.','');
}

function defaultOption(opt, def) {
return (typeof opt == 'undefined' ? def : opt);
}

function formatWithDelimiters(number, precision, thousands, decimal) {
precision = defaultOption(precision, 2);
thousands = defaultOption(thousands, ',');
decimal   = defaultOption(decimal, '.');

if (isNaN(number) || number == null) {
return 0;
}

number = (number/100.0).toFixed(precision);

var parts   = number.split('.'),
dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
cents   = parts[1] ? (decimal + parts[1]) : '';

return dollars + cents;
}

switch(formatString.match(placeholderRegex)[1]) {
case 'amount':
value = formatWithDelimiters(cents, 2);
break;
case 'amount_no_decimals':
value = formatWithDelimiters(cents, 0);
break;
case 'amount_with_comma_separator':
value = formatWithDelimiters(cents, 2, '.', ',');
break;
case 'amount_no_decimals_with_comma_separator':
value = formatWithDelimiters(cents, 0, '.', ',');
break;
case 'amount_no_decimals_with_space_separator':
value = formatWithDelimiters(cents, 0, '.', ' ');
break;
}

return formatString.replace(placeholderRegex, value);
};
}


//////
/*============================================================================
 Ajax the add to cart experience by revealing it in a side drawer
 Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
 (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

 This file includes:
 - Basic Shopify Ajax API calls
 - Ajax cart plugin

 This requires:
 - jQuery 1.8+
 - handlebars.min.js (for cart template)
 - modernizr.min.js
 - snippet/ajax-cart-template.liquid

 Customized version of Shopify's jQuery API
 (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
 ==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
 API Helper Functions
 ==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
 API Functions
 ==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
    }
};

/*============================================================================
 POST to cart/add.js returns the JSON of the cart
 - Allow use of form element instead of just id
 - Allow custom error callback
 ==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {

    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                }
                else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                }
                else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

/*============================================================================
 Ajax Shopify Add To Cart
 ==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

// Public functions
    var init, buildCart, loadCart;

// Private general variables
    var settings, isUpdating, $body;

// Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

// Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, ss_cart_slick, rk_cartSlider, ssAdjustCart, addItemrk;

    /*============================================================================
     Initialise the plugin and define global options
     ==============================================================================*/
    init = function (options) {

// Default settings
        settings = {
            formSelector       : 'form[action^="/cart/add"]',
            cartContainer      : '#CartContainer',
            addToCartSelector  : 'input[type="submit"]',
            cartCountSelector  : null,
            cartCostSelector   : null,
            moneyFormat        : '$',
            disableAjaxCart    : false,
            enableQtySelectors : true
        };

// Override defaults with arguments
        $.extend(settings, options);

// Select DOM elements
        $formContainer     = $(settings.formSelector);
        $cartContainer     = $(settings.cartContainer);
        $addToCart         = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector  = $(settings.cartCostSelector);

// General Selectors
        $body = $(document.body);

// Track cart activity status
        isUpdating = false;

// Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

// Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

// Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
      
    //Run this function in case we're using add to cart of the mini cart
      ssAdjustCart();
      
    };

    loadCart = function () {
    //    $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function (cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function () {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();

			// Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');
			//addtocart text change
			//$('#AddToCartText-product-template').html('Adding...');
			// Remove any previous quantity errors
            $('.qty-error').remove();
			console.log('+-+!');
          	console.log(evt.target);
            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        });
    };
    itemAddedCallback = function (product) {
        $addToCart.removeClass('is-adding').addClass('is-added');
		$('#AddToCartText-product-template').html('✔ Tilføjet til kurv');
        ShopifyAPI.getCart(cartUpdateCallback);
        setTimeout(function() {
        	$('#AddToCartText-product-template').html('Tilføj til kurv');
        }, 9000);
    };

    itemErrorCallback = function (XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');
        if (!!data.message) {
            if (data.status == 422) {
                $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
            }
        }
    };

      
      
    cartUpdateCallback = function (cart) {
      
        // Update quantity and price
        nullsCartUpdate(cart.item_count);

        updateCountPrice(cart);

        buildCart(cart);
    };   
      
    buildCart = function (cart) {
// Start with a fresh cart div
        $cartContainer.empty();

// Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p><img src="//www.festivalkits.dk/cdn/shop/t/46/assets/empty-cart_1x1.png?v=179770348075382792151583331248" width="436" height="772" data-src="//www.festivalkits.dk/cdn/shop/t/46/assets/empty-cart_463x772.png?v=179770348075382792151583331248" data-aspectratio="auto" data-sizes="auto" class="lazyload" /></p>');//.append('<p>' + "Hov du glemte at tilføje en festivalpakke :-(" + '12</p>');
        cartCallback(cart);
        $('#ss_ani_cart').addClass('hide');
        return;
    }

// Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

// Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

        /* Hack to get product image thumbnail
         *   - If image is not null
         *     - Remove file extension, add _small, and re-add extension
         *     - Create server relative link
         *   - A hard-coded url of no-image
         */
        if (cartItem.image != null){
            var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
        } else {
            var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
      
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

// Create item's data object and add to 'items' array
        item = {
            key: cartItem.key,
            line: index + 1, // Shopify uses a 1+ index in the API
            url: cartItem.url,
            img: prodImg,
            name: cartItem.product_title,
          	ssId: cartItem.product_id,
          	ssSku: cartItem.sku,
            variation: cartItem.variant_title,
            properties: cartItem.properties,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            itemQty: cartItem.quantity,
            price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
            vendor: cartItem.vendor,
            linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
            originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
            discounts: cartItem.discounts,
            discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
        };

        items.push(item);
    });

// Gather all cart data and add to DOM
    data = {
        items: items,
        note: cart.note,
        totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      	ssTotalPrice:  Shopify.formatMoney(((cart.total_price / 100 ) > 999 ? 0 : (( 999 - (cart.total_price / 100))*100)),settings.moneyFormat),
      	ssTotalPricet: (cart.total_price / 100 ) > 999 ? 100 : ((cart.total_price / 100)/9.99),      
      	ssTotalPricef: (cart.total_price / 100 ) > 999 ? 'ssFree' : 'ssCost',      
      	ssShippingPrice: ((cart.total_price / 100 ) > 999 ? 'Gratis' : '39 kr.'),      
      	ssCartPrice: Shopify.formatMoney(((cart.total_price / 100 ) > 999 ? cart.total_price : ((cart.total_price / 100 ) + 39)*100),settings.moneyFormat),      	      	      
        totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
    	totalCartDiscountApplied: cart.total_discount === 0 ? false : true
}
	  $cartContainer.append(template(data));
      $('#ss_ani_cart').removeClass();
      $('#ss_ani_cart').addClass(data.ssTotalPricef);
      $('.sscart_remain_price').find('span').html(data.ssTotalPrice);
      $('.sscart_bar_line').attr('data-fill', data.ssTotalPricet);
      $('.sscart_bar_fill').attr('style', 'width:'+data.ssTotalPricet+'%;');
cartCallback(cart);
rk_cartSlider();
ss_cart_slick();
};

cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
nullsGetDay();
nullsFixCart();
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
    }
};

ss_cart_slick = function () {
      $('.ss_recom_product_row').slick({
          	infinite: false,
          	slidesToShow: 1,
          	slidesToScroll: 1,
          	prevArrow: $('.ss_cartSlick-left'),
			nextArrow: $('.ss_cartSlick-right'),
        	responsive: [
    			{
                  breakpoint: 480,
                  settings: {
                      arrows: false,
                      centerMode: true,
                      centerPadding: '7%',    	    		
                  }
    			}
            ]
      });
    };
      
rk_cartSlider = function () {
	
  	$(".ss_recom_product_col").each(function(){
      if($(this).attr("data-ssid") == '273680049')
      {       	
        window.firstProductrk = $(this).html();        
        $(this).remove();        
      }
    });  	
  	$(".rk_cartitem").each(function(){
       	var cartitem_id = $(this).attr("data-carItemId");      	       	
       $(".ss_recom_product_col").each(function(){
         	var slider_id = $(this).attr("data-ssid");
         
         	var prod_singleMadras = '408348669';
         	var prod_doubleMadras = '273683029';
         	var prod_3cmMadras = '1754150404162';
         	var prod_6cmMadras = '1754151190594';
         	var hide_pro = '273683029';
         	var toggle_pro = '273680049';                     	         	         	         
         	
         	if(cartitem_id == toggle_pro)
            {              
            	 firstProductrk = " "; 
            }
         
         	if((cartitem_id == prod_doubleMadras || cartitem_id == prod_singleMadras ))
            {              
              if(firstProductrk != " ")
            	{        			                  	
                	$(".ss_recom_product_row").prepend("<div class='ss_recom_product_col' data-ssid='273680049'>"+ firstProductrk + "</div>");  
                  	firstProductrk = " ";
            	} 
              	
            }
         
         	if(cartitem_id == slider_id){
         		$(this).addClass("hide");  
              	 $(this).remove();
              	if($(this).hasClass('slick-current')){
              		//$(".ss_cartSlick-right").trigger("click");
              	}
            }
         	if(cartitem_id == prod_singleMadras || cartitem_id == prod_3cmMadras || cartitem_id == prod_6cmMadras){
              	if(slider_id == hide_pro){
              		$(this).addClass("hide");
                   $(this).remove();
                }              	
            }        	         	
         	
     	});    
     });    
  	
  };

ssAdjustCart = function () {	    
  $body.on('click', '.ssCart_add', function(er) {      
      var rkFid = $(this).attr("data-cid");
      addItemrk('AddToCartForm'+rkFid)
    }); 
}; 
  
addItemrk = function(form_id) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#'+form_id).serialize(),
      success: itemAddedCallback,
      error: itemErrorCallback
   });
};
      
      
adjustCart = function () {
// Delegate all events because elements reload with the cart

// Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
        if (isUpdating) {
            return;
        }

        var $el = $(this),
            line = $el.data('line'),
            $qtySelector = $el.siblings('.ajaxcart__qty-num');
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));
        var qty = validateQty(qty);

//console.log(line);
      //$('.rk_cart_items .ajaxcart__inner').toggleClass('updateCart');      
       $(this).closest(".ajaxcart__row").toggleClass('updateCart');      
// Add or subtract from the current quantity
        if ($el.hasClass('ajaxcart__qty--plus')) {
            qty += 1;
        } else {
            qty -= 1;
            if (qty <= 0) qty = 0;
        }
      
      $qtySelector.val(qty);

// If it has a data-line, update the cart.
// Otherwise, just update the input's number
        if (line) {
            updateQuantity(line, qty);
        } else {
            $qtySelector.val(qty);
        }
    });

// Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
        if (isUpdating) {
            return;
        }

        var $el = $(this),
            line = $el.data('line'),
            qty = parseInt($el.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

// If it has a data-line, update the cart
        if (line) {
            updateQuantity(line, qty);
        }
    });

// Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
        if (isUpdating) {
            evt.preventDefault();
        }
    });

// Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
        var $el = $(this);
        setTimeout(function() {
            $el.select();
        }, 50);
    });

    function updateQuantity(line, qty) {
        isUpdating = true;

// Add activity classes when changing cart quantities
        var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

        if (qty === 0) {
            $row.parent().addClass('is-removed');
        }

// Slight delay to make sure removed animation is done
        setTimeout(function() {
            ShopifyAPI.changeItem(line, qty, adjustCartCallback);
        }, 250);
    }

// Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
        var newNote = $(this).val();

// Update the cart note in case they don't click update/checkout
        ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
};

adjustCartCallback = function (cart) {
// Update quantity and price
    updateCountPrice(cart);

// Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
        isUpdating = false;
        ShopifyAPI.getCart(buildCart);
    }, 150)
};

createQtySelectors = function() {
// If there is a normal quantity number field in the ajax cart, replace it with our version
  if ($('input[type="number"]:not(.quant)', $cartContainer).length) {
        $('input[type="number"]:not(.quant)', $cartContainer).each(function() {
         
            var $el = $(this),
                currentQty = $el.val();

            var itemAdd = currentQty + 1,
                itemMinus = currentQty - 1,
                itemQty = currentQty;

            var source   = $("#AjaxQty").html(),
                template = Handlebars.compile(source),
                data = {
                    key: $el.data('id'),
                    itemQty: itemQty,
                    itemAdd: itemAdd,
                    itemMinus: itemMinus
                };

// Append new quantity selector then remove original
            $el.after(template(data)).remove();
        });
    }
};

qtySelectors = function() {
// Change number inputs to JS ones, similar to ajax cart but without API integration.
// Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]:not(.quant)');

    if (numInputs.length) {
        numInputs.each(function() {
            var $el = $(this),
                currentQty = $el.val(),
                inputName = $el.attr('name'),
                inputId = $el.attr('id');

            var itemAdd = currentQty + 1,
                itemMinus = currentQty - 1,
                itemQty = currentQty;

            var source   = $("#JsQty").html(),
                template = Handlebars.compile(source),
                data = {
                    key: $el.data('id'),
                    itemQty: itemQty,
                    itemAdd: itemAdd,
                    itemMinus: itemMinus,
                    inputName: inputName,
                    inputId: inputId
                };

// Append new quantity selector then remove original
            $el.after(template(data)).remove();
        });

// Setup listeners to add/subtract from the input
        $('.js-qty__adjust').on('click', function() {
            var $el = $(this),
                id = $el.data('id'),
                $qtySelector = $el.siblings('.js-qty__num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

// Add or subtract from the current quantity
            if ($el.hasClass('js-qty__adjust--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 1) qty = 1;
            }

// Update the input's number
            $qtySelector.val(qty);
        });
    }
};

validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
// We have a valid number!
    } else {
// Not a number. Default to 1.
        qty = 1;
    }
    return qty;
};

module = {
    init: init,
    load: loadCart
};

return module;

}(ajaxCart || {}, jQuery));

  
//jQuery(document).ready(function(t){t(".adi_tent_popview,.popup_slider_container_tent .closeicon,.more_pro_img_tent").on("click",function(){t(".product_popup_tent").toggleClass("active"),t(".product_popup_tent").addClass("animation"),setTimeout(function(){t(".product_popup_tent").removeClass("animation")},500),t("body").css("overflow","hidden")});const s=t(".popup_slider_container_tent");t(document).mouseup(l=>{t(".product_popup_tent").hasClass("active")&&(s.is(l.target)||0!=s.has(l.target).length||(t("body").css("overflow",""),t(".product_popup_tent").toggleClass("active"),t(".LeftArrow_tent").remove(),t(".RightArrow_tent").remove(),t(".tent_popup_image_slider").slick("unslick"),t(".tent_popup_image_slider").empty()))});const l=t(".popup_slider_container");t(document).mouseup(s=>{t(".product_popup").hasClass("active")&&(l.is(s.target)||0!=l.has(s.target).length||(t("body").css("overflow",""),t(".product_popup").removeClass("active")))}),t(".adi_tent_popview").on("click",function(){t(this).prev().find(".slick-slide").each(function(s){var l=t(this).find("img").attr("src");t(".tent_popup_image_slider").append("<div class='tent_popup_image'><img class='carouselImg' src='"+l+"'/></div>"),t(this).hasClass("slick-current")&&(window.popupInt=s)}),t(".tent_popup_image_slider").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,initialSlide:popupInt,dots:!0,autoplay:!1,prevArrow:'<button type="button" class="singleProductLeftArrow_tent"><span class="popArCont"> \t<span class="popAr"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>   <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>  <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> \t</span>\t \t<span class="popArHover"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> \t</span></span> </button>',nextArrow:'<button type="button" class="singleProductRightArrow_tent"> <span class="popArCont">\t<span class="popAr"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>    <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>   <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> \t</span>\t \t<span class="popArHover"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> \t</span></span> </button>'})}),t(".more_pro_img_tent").on("click",function(){t(this).closest(".grid__item").find(".tent_popview .slick-slide").each(function(s){var l=t(this).find("img").attr("src");t(".tent_popup_image_slider").append("<div class='tent_popup_image'><img class='carouselImg' src='"+l+"'/></div>"),t(this).hasClass("slick-current")&&(window.popupInt=s)}),t(".tent_popup_image_slider").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,initialSlide:popupInt,dots:!0,autoplay:!1,prevArrow:'<button type="button" class="singleProductLeftArrow_tent"> <span class="popArCont">\t<span class="popAr"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>    <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>    <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> \t</span>\t \t<span class="popArHover"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> </span>\t</span> </button>',nextArrow:'<button type="button" class="singleProductRightArrow_tent"> <span class="popArCont">\t<span class="popAr"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>     <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>    <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> \t</span>\t \t<span class="popArHover"> \t\t<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg></span> \t</span> </button>'})}),t(".popup_slider_container_tent .closeicon").on("click",function(){t(".LeftArrow_tent").remove(),t(".RightArrow_tent").remove(),t(".tent_popup_image_slider").slick("unslick"),t(".tent_popup_image_slider").empty(),t("body").css("overflow","")})});